<template>
  <el-menu
    router
    mode="horizontal"
    :default-active="path"
    background-color="#095933"
    text-color="#ccc"
    active-text-color="#ffd04b"
  >
    <navi-item v-for="(m, k) in menus" :key="k" :mdata="m" />
  </el-menu>
</template>

<script>
import navigator from '@/components/navi.js'
import NaviItem from '@/components/NaviItem.vue'
export default {
  name: 'Navi',
  components: { NaviItem },
  computed: {
    menus() {
      return navigator.getNaviData()
    },
    path() {
      return navigator.getClippedPath()
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Navi.vue